import React, { useState } from 'react';

import { timeToAgoString, getLocaleUTCDateTimeString } from '@go-shared/lib/time';
import { InlineIcon, TextButton, Popup } from '@spark-labs/avocado-ui';
import { KafkaMessage } from '@go-shared/types/kafkaLogs';

export const KafkaLog: React.FC<KafkaMessage> = props => {
  const { createdAt, n, pl } = props;
  const [timeToAgo, setTimeToAgo] = useState(false);
  const [detailsVisible, setDetailsVisible] = useState(false);

  return (
    <div className="w-full px-4 inline-flex space-between items-center record-row">
      <span className="text-grey-dark mr-8 items-center inline-flex">
        <span className="time-span mr-1">
          {createdAt && timeToAgo
            ? timeToAgoString(new Date(createdAt), new Date())
            : getLocaleUTCDateTimeString(new Date(createdAt))}
        </span>
        <button onClick={() => setTimeToAgo(!timeToAgo)}>
          <InlineIcon name="clock" className="text-grey w-5 h-5" />
        </button>
      </span>
      <span className="w-1/6 justify-center inline-flex">
        <span className="action-pill ">
          <span
            className={`rounded-full w-full text-center uppercase px-5
              py-2 text-xs font-bold mr-3  ${getActionClassname(n)}`}
          >
            {n}
          </span>
        </span>
      </span>
      <div className="ml-3 mr-8 flex flex-col">
        {pl.voyageId && (
          <span>
            <span className="font-semibold mr-3">Voyage ID:</span>
            {pl.voyageId}
          </span>
        )}
        {pl.number && (
          <span>
            <span className="font-semibold mr-3">Voyage Number:</span>
            {pl.number}
          </span>
        )}
      </div>
      <span className="mr-r  flex items-center">
        {pl ? (
          <TextButton
            className="text-blue-dark font-semibold"
            onClick={() => setDetailsVisible(!detailsVisible)}
          >
            Details
            {detailsVisible && (
              <Popup title={'Details'} onClose={() => setDetailsVisible(false)}>
                <ReadableBody body={props} />
              </Popup>
            )}
          </TextButton>
        ) : (
          <h4 className="text-grey m-0">No details available</h4>
        )}
      </span>
    </div>
  );
};

const ReadableBody: React.FC<{ body: any }> = ({ body = {} }) => {
  const [tab, setTab] = useState<'general' | 'payload'>('general');
  const payload = Object.keys(body.pl).map(k => {
    return { key: k, value: body.pl[k] };
  });
  const keyValues = Object.keys(body).map(k => {
    return { key: k, value: body[k] };
  });

  const activeClassname = 'border-b-2 border-grey';
  return (
    <>
      <div className="w-full flex px-5">
        <span className="mr-5">
          <TextButton
            className={tab === 'general' ? activeClassname : 'border-transparent border-b-2'}
            onClick={e => {
              e.stopPropagation();
              setTab('general');
            }}
          >
            General
          </TextButton>
        </span>
        <span>
          <TextButton
            className={tab === 'payload' ? activeClassname : 'border-transparent border-b-2'}
            onClick={e => {
              e.stopPropagation();
              setTab('payload');
            }}
          >
            Payload
          </TextButton>
        </span>
      </div>
      <div className="details-body px-5 py-4">
        <div className="text-left">
          {(tab === 'general' ? keyValues : payload).map((data, i) => {
            if (data.key === '_id') return <></>;
            if (tab === 'general' && data.key === 'pl') return <></>;
            return (
              <div className="mb-4 w-full border-b border-grey-light" key={i}>
                <span className="font-regular py-3 text-grey-darker">{data.key}</span>
                <pre className="font-regular ml-2 py-3 text-grey-dark">
                  {JSON.stringify(data.value, undefined, 2)}
                </pre>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
const getActionClassname = (_action?: string) => {
  if (!_action) return '';
  const action = _action.toLowerCase();
  if (action.includes('delete')) return 'bg-red-light text-white';
  else if (action.includes('create')) return 'bg-green text-white';
  else return 'bg-yellow-lighter';
};
